function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "image-mask-alt",
  clipPathUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.001,0.082 C0,0.076,0.004,0.07,0.008,0.07 L0.993,0.001 C0.998,0,1,0.006,1,0.013 L0.91,0.991 C0.91,0.997,0.906,1,0.902,1 L0.073,0.926 C0.069,0.926,0.066,0.922,0.066,0.916 L0.001,0.082"
}));

var SvgImageMaskAlt = function SvgImageMaskAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageMaskAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-mask-alt.e94e9f61.svg";
export { ForwardRef as ReactComponent };